import {
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  SearchContext,
} from "dash-ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const ApiPluginUsersPageHeader = () => {
  const { t } = useTranslation(["common", "pages"]);
  const { setSearchSlug } = useContext(SearchContext);
  const location = useLocation();

  const companyName = location?.state?.companyName ?? "";
  const [search, setSearch] = useState(companyName);

  useEffect(() => {
    if (companyName) {
      setSearchSlug(companyName);
    }
  }, [companyName]);

  return (
    <Flex alignItems="center" w="100%" px={6} py={4}>
      <InputSearch
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
        }}
        onClear={() => {
          setSearch("");
          setSearchSlug("");
        }}
        w="100%"
        css={"height: 40px"}
        placeholder={"Search by user, email or company name"}
      />
      <PaginationPerPageSelect
        w={130}
        mx={3}
        label={t("common:labels.show") || ""}
      />
    </Flex>
  );
};

export default ApiPluginUsersPageHeader;
